import React from 'react'
import { isEmpty, trim, compose, defaultTo, prop } from 'ramda'
import { useForm, useFetch } from '../../../../hooks'
import Button from '../../../../components/inputs/Button'
import Input from '../../../../components/inputs/Input'
import Buttons from '../../../../modules/Buttons'
import { FormHeader, FormBody, FormBodyText, Icon, Form } from '../../../../modules/Form/styled'

const FormAddHerdGrp = ({ onClickCancel, onClose, translation }) => {
    const { response, doFetch } = useFetch({
        url: '/rpc/add_herdgrp',
        method: 'POST'
    })

    const addHerdGrp = async values => {
        try {
            const res = await doFetch({ data: values });
            if (res === 0) {
                if (translation && translation.error) {
                    setError({ grpname: translation.error })
                }
            }
        } catch (error) {
            console.log(error)
        }

    }

    const validate = values => {
        const isEmptyNumber = compose(isEmpty, trim, defaultTo(''), prop('grpname'))
        if (isEmptyNumber(values)) {
            return {
                grpname: translation ? translation.hint : ''
            }
        }
        return {}
    }

    const { values, errors, handleChange, handleSubmit, setError } = useForm({
        callback: addHerdGrp,
        validate: validate
    })

    const handleClickCancel = () => {
        onClickCancel()
    }

    const handleClickClose = () => {
        onClose && onClose()
        onClickCancel()
    }

    return (
        <Form onSubmit={handleSubmit} noValidate autoComplete="off">
            <FormHeader>
                {translation && translation.title}
            </FormHeader>
            <FormBody>
                {
                    (isEmpty(response.data) || response.data === 0) ?
                        <>
                            <Input
                                type='text'
                                label={translation && translation.placeholder}
                                name='grpname'
                                onChange={handleChange}
                                value={values.grpname}
                                error={errors.grpname}
                                fullWidth
                                maxLength="3"
                            />
                            <Buttons>
                                <Button
                                    type='submit'
                                    fullWidth
                                    green
                                >
                                    {translation && translation.buttons.save}
                                </Button>
                                <Button
                                    type='button'
                                    fullWidth
                                    onClick={handleClickCancel}
                                >
                                    {translation && translation.buttons.cancel}
                                </Button>
                            </Buttons>
                        </>
                        :
                        <>
                            <FormBodyText>
                                <Icon width='80' height='80' viewBox="0 0 24 24">
                                    <polyline points="20 6 9 17 4 12" />
                                </Icon>
                            </FormBodyText>
                            <Button
                                type='button'
                                fullWidth
                                onClick={handleClickClose}
                            >
                                {translation && translation.buttons.close}
                            </Button>
                        </>
                }
            </FormBody>
        </Form>
    )
}

export default FormAddHerdGrp
